import { useEffect } from "react"
import { identify, Identify } from "@amplitude/analytics-browser"
import { getMetaContentMaybe } from "~/common/get-meta-content"

export function useFeedEnabled(hasFeedData: boolean): boolean {
  const feedVariant = getMetaContentMaybe<string>("feed-variant")

  useEffect(() => {
    if (!feedVariant) return
    try {
      const event = new Identify()
      event.set("exp_sharepage_preview_variant", feedVariant)
      identify(event)
    } catch {
      // ignore amplitude errors
    }
  }, [feedVariant])

  return hasFeedData
}
